import React, { useState } from 'react';
import Logo from "../../assets/svg/logo.svg"
import BookDemoButton from '../Start/BookDemoButton';
import { Link, useTranslation } from '../../plugins/i18next/ea-react-i18next';
import { LanguageSwitch } from './LanguageSwitch';


const Navbar = () => {
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const { t } = useTranslation("components", { keyPrefix: 'app.navbar.links' });
    const [selectedMenuPoint, setSelectedMenuPoint] = useState<string>();
    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    }

    React.useEffect(() => {

        let elementId = document.getElementById("navbar");
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                elementId?.classList.add("is-sticky");
            } else {
                elementId?.classList.remove("is-sticky");
            }
        });
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);

    }, []);

    const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    const toggleSubMenu = (id: string) => {
        setSelectedMenuPoint(selectedMenuPoint ? undefined : id);
    }

    return <div id="navbar" className="navbar-area">
        <div className="tarn-nav">
            <div className="container-fluid">
                <nav className="navbar navbar-expand-lg navbar-light">
                    <Link
                        to="/"
                        onClick={() => setCollapsed(true)}
                        className="navbar-brand"
                    >
                        <img src={Logo} alt="EasyLife 365 AG Logo" />
                    </Link>
                    <button
                        onClick={toggleNavbar}
                        className={classTwo}
                        type="button"
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="icon-bar top-bar"></span>
                        <span className="icon-bar middle-bar"></span>
                        <span className="icon-bar bottom-bar"></span>
                    </button>
                    <div className={classOne} id="navbarSupportedContent">
                        <ul className="navbar-nav">
                            <li className="nav-item" key='OurSolutions'>
                                <Link
                                    to="#"
                                    onClick={e => { e.preventDefault(); toggleSubMenu("sol") }}
                                    className="nav-link"
                                    partiallyActive={true}
                                >
                                    {t('ourSolutions.title')} <i className='bx bx-chevron-down'></i>
                                </Link>
                                <div className={`dropdown-menu  ${selectedMenuPoint === "sol" ? "show" : ""} multicolumn`}>
                                    <div className="dropdown-column">
                                        <h4 className="dropdown-heading">{t('ourSolutions.m365Services')}</h4>
                                        <ul className="dropdown-list">
                                            <li key='Collaboration'>
                                                <Link
                                                    to="/products/collaboration"
                                                    activeClassName="active"
                                                    className="nav-link"
                                                    partiallyActive={true}
                                                >
                                                    {t('ourSolutions.collab')}
                                                </Link>
                                            </li>
                                            <li key='mail'>
                                                <Link
                                                    to="/products/mail"
                                                    activeClassName="active"
                                                    className="nav-link"
                                                    partiallyActive={true}
                                                >
                                                    {t('ourSolutions.mail')}
                                                </Link>
                                            </li>
                                            <li key='identity'>
                                                <Link
                                                    to="/products/identity"
                                                    activeClassName="active"
                                                    className="nav-link"
                                                    partiallyActive={true}
                                                >
                                                    {t('ourSolutions.identity')}
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="menu-divider"></div>
                                    <div className="dropdown-column">
                                        <h4 className="dropdown-heading">{t('ourSolutions.games')}</h4>
                                        <ul className="dropdown-list">
                                            <li key='Meet'>
                                                <Link
                                                    to="/products/meet"
                                                    activeClassName="active"
                                                    className="nav-link"
                                                    partiallyActive={true}
                                                >
                                                    {t('ourSolutions.meet')}
                                                </Link>
                                            </li>
                                            <li key='Tipster'>
                                                <Link
                                                    to="/products/tipster"
                                                    activeClassName="active"
                                                    className="nav-link"
                                                    partiallyActive={true}
                                                >
                                                    {t('ourSolutions.tipster')}
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item" key='Resources'>
                                <Link
                                    to="#"
                                    onClick={e => { e.preventDefault(); toggleSubMenu("res") }}
                                    className="nav-link"
                                    partiallyActive={true}
                                >
                                    {t('resources.title')} <i className='bx bx-chevron-down'></i>
                                </Link>
                                <ul className={`dropdown-menu  ${selectedMenuPoint==="res" ? "show" : ""}`}>
                                    <li className="nav-item" key='Docs'>
                                        <a
                                            href="https://docs.easylife365.cloud"
                                            onClick={() => setCollapsed(true)}
                                            className="nav-link"
                                            target="_blank"
                                        >
                                            {t('resources.docs')}
                                        </a>
                                    </li>
                                    <li key='Blog'>
                                        <Link
                                            to="/blog"
                                            activeClassName="active"
                                            className="nav-link"
                                            partiallyActive={true}
                                        >
                                            {t('resources.blog')}
                                        </Link>
                                    </li>
                                    <li key='successstory'>
                                        <Link
                                            to="/success-stories"
                                            activeClassName="active"
                                            className="nav-link"
                                            partiallyActive={true}
                                        >
                                            {t('resources.success-stories')}
                                        </Link>
                                    </li>
                                     <li key='events'>
                                        <Link
                                            to="/events"
                                            activeClassName="active"
                                            className="nav-link"
                                            partiallyActive={true}
                                        >
                                            {t('resources.events')}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item" key='Pricing'>
                                <Link
                                    to="/pricing"
                                    activeClassName="active"
                                    className="nav-link"
                                    partiallyActive={true}
                                >
                                    {t('pricing')}
                                </Link>
                            </li>
                            <li className="nav-item" key='Partners'>
                                <Link
                                    to="#"
                                    onClick={e => { e.preventDefault(); toggleSubMenu("part") }}
                                    className="nav-link"
                                    partiallyActive={true}
                                >
                                    {t('partners.title')} <i className='bx bx-chevron-down'></i>
                                </Link>
                                <ul className={`dropdown-menu ${selectedMenuPoint === "part" ? "show" : ""}`}>
                                    <li key='OurPartners'>
                                        <Link
                                            to="/partners/our-partners"
                                            activeClassName="active"
                                            className="nav-link"
                                            partiallyActive={true}
                                        >
                                            {t('partners.ourPartners')}
                                        </Link>
                                    </li>
                                    <li key='BecomeAPartner'>
                                        <Link
                                            to="/partners/become-a-partner"
                                            activeClassName="active"
                                            className="nav-link"
                                            partiallyActive={true}
                                        >
                                            {t('partners.becomeAPartner')}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item" key='About'>
                                <Link
                                    to="#"
                                    onClick={e => { e.preventDefault(); toggleSubMenu("about") }}
                                    className="nav-link"
                                    partiallyActive={true}
                                >
                                    {t('about')} <i className='bx bx-chevron-down'></i>
                                </Link>
                                <ul className={`dropdown-menu  ${selectedMenuPoint === "about" ? "show" : ""}`}>
                                    <li className="nav-item" key='AboutUs'>
                                        <Link
                                            to="/aboutus"
                                            activeClassName="active"
                                            className="nav-link"
                                        >
                                            {t('aboutus')}
                                        </Link>
                                    </li>
                                    <li className="nav-item" key='ChaosMonster'>
                                        <Link
                                            to="/chaosmonster"
                                            activeClassName="active"
                                            className="nav-link"
                                        >
                                            {t('chaosmonster')}
                                        </Link>
                                    </li>
                                    <li className="nav-item" key='ContactUs'>
                                        <Link
                                            to="/support"
                                            activeClassName="active"
                                            className="nav-link"
                                        >
                                            {t('contactus')}
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                            <LanguageSwitch toggleSubMenu={toggleSubMenu} selectedMenuPoint={selectedMenuPoint} />
                        </ul>
                        <div className="others-option d-flex align-items-center">
                            <div className="option-item">
                                <BookDemoButton />
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </div>
}

export default Navbar;
